// 'use client';

// import { useState, useEffect } from 'react';
// import Image, { ImageProps } from 'next/image';
// import image from './../../public/Logo.png';

// // Normalize and validate the image src
// const normalizeSrc = (src?: string): string => {
//   if (!src || typeof src !== 'string' || src.trim() === '') {
//     return image.src;
//   }

//   // Allow full URLs and root-relative paths
//   if (
//     src.startsWith('http://') ||
//     src.startsWith('https://') ||
//     src.startsWith('/')
//   ) {
//     return src;
//   }

//   // Assume relative path, add leading slash
//   return '/' + src;
// };

// interface NextImageProps extends Omit<ImageProps, 'src'> {
//   src?: string;
//   fallbackSrc?: string;
// }

// const NextImage: React.FC<NextImageProps> = ({
//   src,
//   fallbackSrc = image.src,
//   alt = 'image',
//   ...props
// }) => {
//   const [imgSrc, setImgSrc] = useState<string>(normalizeSrc(src));

//   useEffect(() => {
//     setImgSrc(normalizeSrc(src));
//   }, [src]);

//   const handleError = () => {
//     console.warn(
//       `Image failed to load: ${imgSrc}. Falling back to: ${fallbackSrc}`
//     );
//     setImgSrc(normalizeSrc(fallbackSrc));
//   };

//   return <Image {...props} src={imgSrc} onError={handleError} alt={alt} />;
// };

// export default NextImage;


// ===============================================================================



// 'use client';

// import { useState, useEffect } from 'react';
// import Image, { ImageProps } from 'next/image';
// import defaultFallback from './../../public/images/placeholder.jpg';

// // Normalize path
// const normalizeSrc = (src?: string): string => {
//   if (!src || typeof src !== 'string' || src.trim() === '') {
//     return defaultFallback.src;
//   }

//   if (
//     src.startsWith('http://') ||
//     src.startsWith('https://') ||
//     src.startsWith('/')
//   ) {
//     return src;
//   }

//   return '/' + src;
// };

// interface NextImageProps extends Omit<ImageProps, 'src'> {
//   src?: string;
//   fallbackSrc?: string;
//   useFill?: boolean; // allow using fill if needed
//   aspectRatio?: string; // '16 / 9', '4 / 3', etc.
// }

// const NextImage: React.FC<NextImageProps> = ({
//   src,
//   fallbackSrc = defaultFallback.src,
//   alt = 'image',
//   unoptimized = true,
//   ...props
// }) => {
//   const [imgSrc, setImgSrc] = useState(normalizeSrc(src));
//   const [hasError, setHasError] = useState(false);

//   useEffect(() => {
//     setImgSrc(normalizeSrc(src));
//   }, [src]);

//   if (hasError) {
//     return (
//       <>
//         {
//           // eslint-disable-next-line @next/next/no-img-element
//           <img
//             src={src}
//             onError={(e) => {
//               (e.target as HTMLImageElement).src = '/images/placeholder.jpg';
//             }}
//             alt={alt}
//             style={{ objectFit: 'cover' }}
//             {...props}
//           />
//         }
//       </>
//     );
//   }

//   return (
//     <Image
//       src={imgSrc}
//       onError={() => setHasError(true)}
//       alt={alt}
//       {...props}
//       unoptimized={unoptimized}
//     />
//   );
// };

// export default NextImage;




'use client';

import { useState, useEffect } from 'react';
import Image, { ImageProps } from 'next/image';
import defaultFallback from './../../public/images/placeholder.jpg';

// Normalize path
const normalizeSrc = (src?: string): string => {
  if (!src || typeof src !== 'string' || src.trim() === '') {
    return defaultFallback.src;
  }

  if (
    src.startsWith('http://') ||
    src.startsWith('https://') ||
    src.startsWith('/')
  ) {
    return src;
  }

  return '/' + src;
};

interface NextImageProps extends Omit<ImageProps, 'src'> {
  src?: string;
  fallbackSrc?: string;
  useFill?: boolean;
  aspectRatio?: string; // <-- SAFE to accept
}

const NextImage: React.FC<NextImageProps> = ({
  src,
  fallbackSrc = defaultFallback.src,
  alt = 'image',
  unoptimized = true,
  aspectRatio,              // <-- CONSUMED here
  style,
  ...props                  // <-- CLEAN props only
}) => {
  const [imgSrc, setImgSrc] = useState(normalizeSrc(src));
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setImgSrc(normalizeSrc(src));
  }, [src]);

  const mergedStyle = {
    ...(aspectRatio ? { aspectRatio } : {}),
    ...style,
  };

  if (hasError) {
    return (
      // eslint-disable-next-line @next/next/no-img-element
      <img
        src={src || fallbackSrc}
        onError={(e) => {
          (e.target as HTMLImageElement).src = '/images/placeholder.jpg';
        }}
        alt={alt}
        style={{ objectFit: 'cover', ...mergedStyle }}
        {...props}
      />
    );
  }

  return (
    <Image
      src={imgSrc}
      onError={() => setHasError(true)}
      alt={alt}
      style={mergedStyle}
      unoptimized={unoptimized}
      {...props}
    />
  );
};

export default NextImage;
